import script from "./NewView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewView.vue?vue&type=script&setup=true&lang=js"

import "./NewView.vue?vue&type=style&index=0&id=a850339e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a850339e"]])

export default __exports__